import { GuidanceMetadata } from '@core/domain/models/reviewItemMetadata/guidancMetadata'
import axios from 'axios'

type GuidanceResult = {
  id: string
  title: string
  fulltext: string
  reference: string
  source: string
  pdfLink: string
  type: string
  publicationDate: string
}

export class GuidanceApiClient {
  private readonly baseUrl =
    location.protocol + '//' + location.host + '/guidance'

  async search({
    pagination = {
      limit: 5000,
      offset: 0,
    },
    sources,
  }: {
    sources: string[]
    pagination?: { limit: number; offset: number }
  }): Promise<{ results: GuidanceMetadata[]; totalFound: number }> {
    const { results, totalFound } = await this.findGuidance({
      sources,
      pagination,
    })

    return {
      results: this.mapResultsToGuidance(results),
      totalFound,
    }
  }

  private async findGuidance({
    pagination,
    sources,
  }: {
    sources: string[]
    pagination: { limit: number; offset: number }
  }): Promise<{ results: GuidanceResult[]; totalFound: number }> {
    try {
      const solrQuery = `${encodeURIComponent('*:*')}`
      const sourceFilter = sources
        .map((a) => `source:"${encodeURIComponent(a)}"`)
        .join(' OR ')
      const fq = sourceFilter ? `&fq=${sourceFilter}` : ''

      const solrUrl = `${this.baseUrl}/?q=${solrQuery}${fq}&start=${pagination.offset}&rows=${pagination.limit}&wt=json`

      const response = await axios.get(solrUrl)

      return {
        results: (response.data.response.docs || []) as GuidanceResult[],
        totalFound: response.data.response.numFound || 0,
      }
    } catch (error) {
      console.error('Error searching documents:', error)
      return {
        results: [],
        totalFound: 0,
      }
    }
  }

  private mapResultsToGuidance(results: GuidanceResult[]): GuidanceMetadata[] {
    if (!results || !Array.isArray(results)) {
      return []
    }
    return results.map(
      (result) =>
        new GuidanceMetadata({
          reference: result.reference,
          title: result.title[0],
          attachmentLink: result.pdfLink,
          publishYear: result.publicationDate,
        }),
    )
  }
}
